var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-fluid p-2 m-0 text-white text-center bg-offline"
    },
    [
      _c(
        "div",
        { staticClass: "fs-16 font-weight-bold" },
        [
          _c("font-awesome-icon", {
            staticClass: "mr-1",
            attrs: { icon: ["fas", "wifi"] }
          }),
          _vm._v("\n    NO INTERNET CONNECTION\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "fs-14" }, [
        _vm._v(
          "\n    Please check your Wi-Fi or Mobile Data before continuing with the application\n  "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "fs-14 font-weight-bold" }, [
        _vm._v(
          "\n    Leaving the browser, clicking the back button or navigating to another website will require the start of a new application\n  "
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }